import React from 'react'
import { ResponsiveLayout } from 'containers'
import { AccountManagementWithRollout } from './AccountManagementWithRollout'
import Header from 'containers/ResponsiveLayout/Header'

export const AccountManagementMobileWrapper = () => {
  return (
    <ResponsiveLayout
      menu={<Header />}
      content={
        <div style={{ padding: '0 16px 8px' }}>
          <AccountManagementWithRollout />
        </div>
      }
    />
  )
}
